import React, { useState, useEffect, useCallback } from "react";
import { useTelegram } from "../../hooks/useTelegram";
import Back from "../../assets/back.svg";
import "./BannerPage.scss";

const BannerPage = ({ onClose, selectedBanner }) => {
	const [isVisible, setIsVisible] = useState(false);

	const { tg, triggerHapticFeedback } = useTelegram();
	const filePath = process.env.REACT_APP_FILE_PATH;

	useEffect(() => {
		const timeout = setTimeout(() => {
			setIsVisible(true);
		}, 10);

		return () => clearTimeout(timeout);
	}, []);

	const handleClose = useCallback(() => {
		setIsVisible(false);

		setTimeout(() => {
			if (typeof onClose === "function") {
				onClose();
			}
		}, 300);
	}, [onClose]);

	const handleOpenLink = useCallback(
		async (link) => {
			if (!link) return;

			try {
				triggerHapticFeedback?.("impact", "medium");

				if (link.startsWith("https://t.me/")) {
					if (tg?.openTelegramLink) {
						tg.openTelegramLink(link);
					} else {
						window.open(link, "_blank");
					}
					return;
				}

				if (tg?.openLink) {
					tg.openLink(link);
				} else {
					window.open(link, "_blank");
				}
			} catch (error) {
				console.error("Failed to open banner link:", error);
			}
		},
		[tg, triggerHapticFeedback],
	);

	const handleButtonClick = useCallback(
		async (link) => {
			if (!selectedBanner || !link) return;

			await handleOpenLink(link);
		},
		[selectedBanner, handleOpenLink],
	);

	if (!selectedBanner) {
		return null;
	}

	return (
		<div className={`banner-cont ${isVisible ? "visible" : ""}`}>
			<div className="banner">
				<div className="nav">
					<div className="back-nav">
						<div className="back-btn" onClick={handleClose}>
							<button type="button">
								<img src={Back} alt="back" />
							</button>
						</div>
						<h2>На Главную</h2>
					</div>
				</div>

				<div className="banner-content">
					<div className="banner-image">
						<img
							src={`${filePath}/Banners/${selectedBanner.fileName}`}
							alt={selectedBanner.name || "Banner"}
						/>
						<div className="title">
							<h1>{selectedBanner.name}</h1>
						</div>
						<div className="grad"></div>
					</div>

					<div className="banner-text">
						<p>{selectedBanner.description}</p>

						{selectedBanner.showButton1 && selectedBanner.link1 && (
							<div className="btn">
								<button
									type="button"
									onClick={() => handleButtonClick(selectedBanner.link1)}
								>
									{selectedBanner.linkButton1?.trim() || "Перейти"}
								</button>
							</div>
						)}

						{selectedBanner.showButton2 && selectedBanner.link2 && (
							<div className="btn">
								<button
									type="button"
									onClick={() => handleButtonClick(selectedBanner.link2)}
								>
									{selectedBanner.linkButton2?.trim() || "Перейти"}
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default BannerPage;
